import styled, { css } from 'styled-components';
import variables from '@styles/variables';
import GridCol from '@molecules/GridCol/GridCol';
import { rem } from 'polished';
import Link from '@atoms/Link/Link';
import Grid from '@atoms/Grid/Grid';
import Product from '@molecules/Product/Product';
import Config from '@config';

export const StyledSmallGridComponent = styled(GridCol)`
  z-index: 1;
  width: 100%;
  border: ${rem(1)} solid ${variables.colors.mediumGray};
  border-radius: ${rem(8)};
`;

export const StyledGrid = styled(Grid)`
  height: 100%;
  margin: 0;
`;

export const StyledProduct = styled(Product)<{ $imagePosition: 'LEFT' | 'RIGHT' }>`
  border: 0 !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  width: calc(100% + ${rem(6)});

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: calc(100% + ${rem(8)});
  }

  ${(props) =>
    props.$imagePosition === 'LEFT' &&
    css`
      border-left: ${rem(1)} solid ${variables.colors.lightGray} !important;
      border-radius: 0 ${rem(8)} ${rem(8)} 0;
      margin-left: ${rem(-6)} !important;

      ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
        margin-left: ${rem(-8)} !important;
      }
    `}
  ${(props) =>
    props.$imagePosition === 'RIGHT' &&
    css`
      border-right: ${rem(1)} solid ${variables.colors.lightGray} !important;
      border-radius: ${rem(8)} 0 0 ${rem(8)};
    `}
`;

export const StyledProductCol = styled(GridCol)`
  display: block;
`;

export const StyledImageCol = styled(GridCol)<{ $imagePosition: 'LEFT' | 'RIGHT' }>`
  position: relative;
  overflow: hidden;
  z-index: 1;
  width: calc(100% + ${rem(6)});

  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    width: calc(100% + ${rem(8)});
  }

  ${(props) =>
    props.$imagePosition === 'LEFT' &&
    css`
      border-radius: ${rem(8)} 0 0 ${rem(8)};
    `}
  ${(props) =>
    props.$imagePosition === 'RIGHT' &&
    css`
      border-radius: 0 ${rem(8)} ${rem(8)} 0;
      margin-left: ${rem(-6)} !important;

      ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
        margin-left: ${rem(-8)} !important;
      }
    `}
`;

export const StyledImage = styled.img`
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const StyledLink = styled(Link)`
  display: block;
  height: 100%;
  color: unset !important;
`;
